import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MainMenuComponent } from './main-menu.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IQConnectEmulatorModule } from '../iq-connect-emulator/iq-connect-emulator.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    IQConnectEmulatorModule
  ],
  declarations: [MainMenuComponent],
  exports: [MainMenuComponent],
})
export class MainMenuModule { }